/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'auth-attribute-match-readonly';
const prefix = `${moduleName}.${componentName}`;

export const authAttributeMatchLabel = `${prefix}.authAttributeMatchLabel`;

export const ENGLISH = {
    [authAttributeMatchLabel]: 'Attribute',
};
